.wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.tabsSection {
  display: flex;
  justify-content: center;
}

.filtersSection {
  display: flex;
  justify-content: center;
}

.gridSection {
  margin-top: 8px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 18px;
}

.emptyState {
  text-align: center;
  padding: 60px 20px;
  font-size: 15px;
  color: #888;
}

@media (max-width: 600px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}
